import React, { useState, useEffect, useCallback } from 'react'
import TransportQualificationBlock from './TransportQualificationBlock'
import TransportReglementsBlock from './TransportReglementsBlock'
import TransportRecoursBlock from './TransportRecoursBlock'
import TransportLimitationBlock from './TransportLimitationBlock'
import TransportEcheancesBlock from './TransportEcheancesBlock'

const API = process.env.REACT_APP_BACKEND_URL

export const TYPES_POLICE_TRANSPORT = ['rc_transport', 'ad_valorem']

export function isSinistreTransport(sinistre) {
  return !!sinistre && (TYPES_POLICE_TRANSPORT.includes(sinistre.polices?.type_police) || !!sinistre.qualification || sinistre.type_sinistre === 'transport')
}

export const fmtEur = (v) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(v) || 0)

export default function TransportSinistreBlocks({ sinistre, sinistreId, onRefresh, userId }) {
  const [data, setData] = useState(null)
  const transport = isSinistreTransport(sinistre)

  const load = useCallback(async () => {
    if (!transport) return
    try {
      const res = await fetch(`${API}/api/sinistres/${sinistreId}/transport`)
      if (res.ok) setData(await res.json())
    } catch { /* silencieux */ }
  }, [sinistreId, transport])

  useEffect(() => { load() }, [load, sinistre?.qualification, sinistre?.police_id, sinistre?.montant_regle_total, sinistre?.recours_encaisse])

  if (!transport) return null
  const refreshAll = async () => { await load(); onRefresh?.() }

  return (
    <div className="space-y-4" data-testid="transport-blocks">
      <TransportQualificationBlock sinistre={sinistre} sinistreId={sinistreId} data={data} onRefresh={refreshAll} userId={userId} />
      <TransportLimitationBlock sinistre={sinistre} sinistreId={sinistreId} onRefresh={refreshAll} />
      <TransportEcheancesBlock sinistreId={sinistreId} refreshKey={`${sinistre.date_livraison}-${sinistre.date_reserves}-${sinistre.convention_id}`} />
      <TransportReglementsBlock sinistre={sinistre} sinistreId={sinistreId} data={data} onRefresh={refreshAll} userId={userId} />
      <TransportRecoursBlock sinistreId={sinistreId} data={data} onRefresh={refreshAll} userId={userId} />
    </div>
  )
}
